import React from "react";
import { buttonConfig } from "../shared/styleconfig";

const ButtonComponent = ({ buttontext, className, onClick = () => {} }) => {
  return (
    <button
      className={`border rounded-[47px] border-solid text-center ${className} ${buttonConfig}`}
      onClick={() => onClick()}>
      {buttontext}
    </button>
  );
};

export default ButtonComponent;
